import { render, staticRenderFns } from "./ConfirmApproveWowStreamer.vue?vue&type=template&id=24615fce&scoped=true"
import script from "./ConfirmApproveWowStreamer.vue?vue&type=script&lang=js"
export * from "./ConfirmApproveWowStreamer.vue?vue&type=script&lang=js"
import style0 from "./ConfirmApproveWowStreamer.vue?vue&type=style&index=0&id=24615fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24615fce",
  null
  
)

export default component.exports